import e from"./Highlighter.vue_vue&type=script&lang.js";import{render as t}from"./Highlighter.vue_vue&type=template&id=92153c3e&lang.js";e.render=t,e.__file="src/components/Highlighter.vue";export default e;
//# sourceMappingURL=Highlighter.vue.js.map
